import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Search, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

const todayString = () => {
  const d = new Date();
  const days = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
  const months = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
  const label = `${days[d.getDay()]} ${d.getDate()} ${months[d.getMonth()]}`;
  return label.charAt(0).toUpperCase() + label.slice(1);
};

const Header = ({ onMenuClick, onSearchClick }) => {
  return (
    <header className="w-full bg-[#faf7f2] border-b border-[#e6ddd0]">
      {/* Top strip: social bar visible on desktop */}
      <div className="hidden md:flex items-center justify-between px-6 lg:px-10 py-2 text-[11px] text-[#7a716c] border-b border-[#e6ddd0]">
        <div className="flex items-center gap-4">
          <a href="#" aria-label="Facebook" className="hover:text-[#8b2c3f] transition-colors"><Facebook size={13} /></a>
          <a href="#" aria-label="X" className="hover:text-[#8b2c3f] transition-colors"><Twitter size={13} /></a>
          <a href="#" aria-label="Instagram" className="hover:text-[#8b2c3f] transition-colors"><Instagram size={13} /></a>
        </div>
        <div className="tracking-wide">{todayString()}</div>
        <div className="flex items-center gap-4 uppercase text-[11px] font-semibold">
          <a href="#" className="hover:text-[#8b2c3f] transition-colors">Derniers articles</a>
          <a href="#" className="hover:text-[#8b2c3f] transition-colors">Articles populaires</a>
        </div>
      </div>

      {/* Main header row */}
      <div className="flex items-center justify-between px-4 md:px-8 lg:px-10 py-5">
        <div className="flex items-center gap-3 md:gap-5 flex-1">
          <button
            onClick={onMenuClick}
            aria-label="Ouvrir le menu"
            className="text-gray-800 hover:text-[#8b2c3f] transition-colors"
          >
            <Menu size={22} />
          </button>
          <span className="hidden md:inline text-xs text-gray-500 tracking-wide">{todayString()}</span>
        </div>

        <Link to="/" className="flex-1 text-center group">
          <div className="flex flex-col items-center">
            <span
              className="font-bold tracking-[0.28em] text-[22px] md:text-[32px] text-[#1a1414] select-none leading-none"
              style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: 'italic' }}
            >
              Bcool<span className="text-[#8b2c3f]">Store</span>
            </span>
            <span
              className="mt-1 text-[9px] md:text-[10px] uppercase tracking-[0.4em] text-[#c9a961] font-semibold"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              — Histoires & Confidences —
            </span>
          </div>
        </Link>

        <div className="flex items-center gap-4 md:gap-5 flex-1 justify-end">
          <button
            onClick={onSearchClick}
            aria-label="Rechercher"
            className="text-gray-800 hover:text-[#8b2c3f] transition-colors"
          >
            <Search size={19} />
          </button>
          <a href="#" aria-label="Facebook" className="hidden md:inline text-gray-700 hover:text-[#8b2c3f] transition-colors">
            <Facebook size={17} />
          </a>
          <a href="#" aria-label="X" className="hidden md:inline text-gray-700 hover:text-[#8b2c3f] transition-colors">
            <Twitter size={17} />
          </a>
          <a href="#" aria-label="Instagram" className="hidden md:inline text-gray-700 hover:text-[#8b2c3f] transition-colors">
            <Instagram size={17} />
          </a>
          <a href="#" aria-label="YouTube" className="hidden md:inline text-gray-700 hover:text-[#8b2c3f] transition-colors">
            <Youtube size={19} />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
export { todayString };
